{
    "name": "ayyildiz-checklist-platform-admin",
    "version": "2.0.3",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "start:test": "ng serve --configuration=test",
        "start:staging": "ng serve --configuration=staging",
        "start:prod": "ng serve --configuration=production",
        "build": "ng build",
        "test": "ng test",
        "lint": "ng lint",
        "e2e": "ng e2e",
        "build:test": "grunt clean && ng build --configuration=test && grunt build_docker",
        "build:staging": "grunt clean && ng build --configuration=staging && grunt build",
        "build:production": "grunt clean && ng build --configuration=production && grunt build",
        "audit-html": "npm audit --json | npm-audit-html --output audit-reports/report.html",
        "format": "npx prettier 'src/**/*.{js,jsx,ts,tsx,html,css,scss}' --write"
    },
    "private": true,
    "browserslist": [
        "> 1%",
        "last 3 versions"
    ],
    "engines": {
        "node": ">=24.11.0 <25"
    },
    "dependencies": {
        "@angular/animations": "20.3.21",
        "@angular/cdk": "^20.2.14",
        "@angular/common": "20.3.21",
        "@angular/compiler": "20.3.21",
        "@angular/core": "20.3.21",
        "@angular/forms": "20.3.21",
        "@angular/localize": "20.3.21",
        "@angular/material": "^20.0.0",
        "@angular/platform-browser": "20.3.21",
        "@angular/platform-browser-dynamic": "20.3.21",
        "@angular/router": "20.3.21",
        "@googlemaps/js-api-loader": "2.0.2",
        "@impacgroup/angular-access-management": "20.0.0",
        "@impacgroup/angular-baselib": "20.0.0",
        "@impacgroup/angular-firebase": "20.0.3",
        "@impacgroup/angular-languages": "20.0.0",
        "@impacgroup/angular-mailtemplates": "20.0.2",
        "@impacgroup/angular-oauth-base": "20.0.0",
        "@impacgroup/angular-selfservice": "20.0.0",
        "@impacgroup/angular-systemhealth": "20.0.0",
        "@impacgroup/ayyildiz-checklist-platform-api-dtos": "2.0.4",
        "@impacgroup/chartist-plugin-tooltip": "1.0.0",
        "@ng-select/ng-select": "^20.0.0",
        "@ngx-translate/core": "^17.0.0",
        "@ngx-translate/http-loader": "^17.0.0",
        "@nitro-n/ngx-ace-editor": "20.0.1",
        "animate.css": "^4.1.1",
        "bootstrap": "^5.3.8",
        "brace": "^0.11.1",
        "chartist": "^1.5.0",
        "chartist-plugin-legend": "^0.6.2",
        "class-transformer": "0.5.1",
        "class-validator": "0.14.2",
        "core-js": "^3.47.0",
        "datatables.net": "^2.3.6",
        "datatables.net-dt": "^2.3.6",
        "file-saver": "2.0.5",
        "google-libphonenumber": "3.2.43",
        "i": "^0.3.7",
        "jquery": "^3.7.1",
        "jszip": "3.10.1",
        "material-design-iconic-font": "^2.2.0",
        "moment": "2.30.1",
        "ng-chartist": "^10.0.0",
        "ng5-slider": "^1.2.6",
        "ngx-autosize": "^2.0.4",
        "ngx-bootstrap": "^20.0.0",
        "ngx-dropzone-wrapper": "^17.0.0",
        "ngx-mask": "^20.0.0",
        "ngx-papaparse": "^5.0.0",
        "ngx-quill": "^28.0.0",
        "ngx-scrollbar": "^19.0.0",
        "popper.js": "1.16.1",
        "quill": "^2.0.3",
        "reflect-metadata": "0.2.2",
        "rxjs": "~7.8.2",
        "sourcemapped-stacktrace": "1.1.11",
        "tslib": "^2.8.1",
        "zone.js": "~0.15.1"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "20.3.21",
        "@angular/cli": "20.3.21",
        "@angular/compiler-cli": "20.3.21",
        "@angular/language-service": "20.3.21",
        "@types/chartist": "^1.0.0",
        "@types/datatables.net": "^1.10.19",
        "@types/google.maps": "3.58.1",
        "@types/jasmine": "~6.0.0",
        "@types/jasminewd2": "~2.0.13",
        "@types/jquery": "^3.5.33",
        "@types/node": "^20.0.0",
        "codelyzer": "^6.0.0",
        "grunt": "1.6.1",
        "grunt-cli": "1.5.0",
        "grunt-contrib-clean": "2.0.1",
        "grunt-contrib-compress": "2.0.0",
        "grunt-contrib-copy": "1.0.0",
        "jasmine-core": "^5.0.0",
        "jasmine-spec-reporter": "~7.0.0",
        "karma": "~6.4.2",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage-istanbul-reporter": "~3.0.3",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.1.0",
        "ng-packagr": "^20.3.2",
        "npm-audit-html": "1.5.0",
        "protractor": "~7.0.0",
        "ts-node": "~8.3.0",
        "tslint": "~6.1.0",
        "typescript": "~5.9.3"
    }
}
